"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReverseDatePartFormatMap = exports.DatePartFormatMap = exports.DatePartEnum = void 0;

var _DatePartFormatMap;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DatePartEnum;
exports.DatePartEnum = DatePartEnum;

(function (DatePartEnum) {
  DatePartEnum["DATE"] = "date";
  DatePartEnum["MONTH"] = "month";
  DatePartEnum["YEAR"] = "year";
})(DatePartEnum || (exports.DatePartEnum = DatePartEnum = {}));

var DatePartFormatMap = (_DatePartFormatMap = {}, _defineProperty(_DatePartFormatMap, DatePartEnum.DATE, 'dd'), _defineProperty(_DatePartFormatMap, DatePartEnum.MONTH, 'mm'), _defineProperty(_DatePartFormatMap, DatePartEnum.YEAR, 'yyyy'), _DatePartFormatMap);
exports.DatePartFormatMap = DatePartFormatMap;
var ReverseDatePartFormatMap = {
  dd: DatePartEnum.DATE,
  mm: DatePartEnum.MONTH,
  yyyy: DatePartEnum.YEAR
};
exports.ReverseDatePartFormatMap = ReverseDatePartFormatMap;